module.exports = __webpack_public_path__ + "static/media/service.89a009a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logos/service.png
// module id = 221
// module chunks = 0